import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'
import Member from '../models/instance/Member'
import App from '../models/instance/App'
import AppointmentSelection from '../models/instance/AppointmentSelection'
import axios from 'axios';
import config from '@/../config.js'
import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {name:'Login',path: '/login',component: () => import('@/components/Login/Login.vue')}

  ,{name:'Station',path: '/station/:station_code',component: () => import('@/components/Station/Station.vue')}
  ,{name:'StationActivate',path: '/station/activate/:station_code',component: () => import('@/components/StationActivate/StationActivate.vue')}
  
  ,{name:'Appointment',path: '/appointment',component: () => import('@/components/Appointment/Appointment.vue')}
  ,{name:'AppointmentNew',path: '/appointment/new',component: () => import('@/components/AppointmentNew/AppointmentNew.vue')}
  ,{name:'AppointmentNew_custompage',path: '/appointment/new/custompage/:custompage',component: () => import('@/components/AppointmentNew/AppointmentNew.vue')}
  ,{name:'AppointmentNewStep',path: '/appointment/new/:step_id',component: () => import('@/components/AppointmentNew/AppointmentNewStep.vue')}

  ,{name:'AppointmentManage',path: '/appointment/manage/',component: () => import('@/components/AppointmentManage/AppointmentManage.vue')}
  ,{name:'AppointmentManage_Station',path: '/appointment/manage/:station_code',component: () => import('@/components/AppointmentManage/AppointmentManage.vue')}

  ,{name:'Activate',path: '/activate',component: () => import('@/components/Activate/Activate.vue')}

  ,{name:'RegisterForm',path: '/registerform/:station_code',component: () => import('@/components/RegisterForm/RegisterForm.vue')}
  
  ,{name:'Success',path: '/success',component: () => import('@/components/Common/Success.vue')}
  ,{name:'Error',path: '/error',component: () => import('@/components/Common/Error.vue')}

  ,{name:'Queuedetail',path: '/queuedetail/:qrcode',component: () => import('@/components/Queuedetail/Queuedetail.vue')}
  ,{name:'Queuetracking',path: '/queuetracking/:qrcode',component: () => import('@/components/Queuetracking/Queuetracking.vue')}

  ,{name:'Queuestation',path: '/queuestation/:station_code',component: () => import('@/components/Queuestation/Queuestation.vue')}
  ,{name:'Queuemanage',path: '/queuemanage/:station_code',component: () => import('@/components/Queuemanage/Queuemanage.vue')}
  ,{name:'Queueurl',path: '/queueurl/:station_code',component: () => import('@/components/Queueurl/Queueurl.vue')}

  ,{name:'SpecialMarketOrder',path: '/special/market/order',component: () => import('@/components/Special/SpecialMarketOrder.vue')}
  ,{name:'SpecialMarketOrderSuccess',path: '/special/market/success',component: () => import('@/components/Special/SpecialMarketOrderSuccess.vue')}
  ,{name:'SpecialMarketOrderPay',path: '/special/market/pay/:order_id',component: () => import('@/components/Special/SpecialMarketOrderPay.vue')}
  ,{name:'SpecialMarketOrderList',path: '/special/market/list',component: () => import('@/components/Special/SpecialMarketOrderList.vue')}
  
]

// eslint-disable-next-line no-new
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


const public_url = ['Login','Error','Queuedetail','Queueurl']
router.beforeEach((to, from, next) => {

  if(to.name=='AppointmentNewStep' && AppointmentSelection.getStationCode()==null && to.params.reserve_accept_by==undefined){
    router.replace({name:'Appointment'})
  }

  if(to.query.app!=undefined){
    App.setAppId(to.query.app)
    var que = store.commit('addLoading')
    axios
    .post(config.api.url.public.line.get_appconfig,{app_id:to.query.app})
    .then(response => {
        App.setAppConfig(response.data)
        store.commit('finishLoading',que)
    })
  }

  i18n.locale = Member.getLang()
  if(!public_url.includes(to.name) && (!Member.isLogin() || !App.getAppId())){
    next({ name: 'Error' })
  }else{
    next()
  }
})

export default router
